import { FieldValues, FieldPath } from "react-hook-form"
import { SelectField } from "../SelectField"
import type { TimezoneFieldProps } from "./TimezoneField.types"
import { TIMEZONE_OPTIONS } from "./TimezoneField.utils"

export function TimezoneField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  placeholder = "Select a timezone",
  disabled,
  size,
  loading,
}: TimezoneFieldProps<TFieldValues, TName>) {
  return (
    <SelectField
      name={name}
      control={control}
      label={label}
      required={required}
      help={help}
      options={TIMEZONE_OPTIONS}
      placeholder={placeholder}
      disabled={disabled}
      size={size}
      loading={loading}
      showSearch
      filterOption={(input, option) =>
        (option?.label?.toString() ?? "")
          .toLowerCase()
          .includes(input.toLowerCase()) ||
        (option?.value?.toString() ?? "")
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      allowClear
    />
  )
}
